<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <template v-if="parameters.length > 0">
        <template v-for="(group, index) in parameters" :key="index">
          <SegmentGroupSetup
            :group="group"
            :segments="segments"
            :activities-url="activitiesUrl"
            @update-group="onUpdateGroup(group, $event)"
            @delete-group="onDeleteGroup(group)"
          ></SegmentGroupSetup>
          OR
        </template>
      </template>
      <template v-else>
        <div class="card text-center my-3">
          <div class="card-body">
            <h4 class="card-title">{{ $t('Target not set') }}</h4>
            <p class="card-text">{{ $t("Define the recipient criteria here") }}</p>
          </div>
        </div>
      </template>
      <div>
        <button class="btn btn-outline-primary" v-on:click.prevent="addNewGroup()">
          {{ $t('Add new group') }}
        </button>
      </div>
    </div>
    <div class="col-12 col-md-4 my-3">
      <div class="card text-center bg-secondary ">
        <div class="card-body text-white">
          <p class="card-text">{{ $t('Recipients') }}</p>
          <h3 class="card-title">
            <span v-if="typeof recipients === 'string'">
              {{ recipients }}
            </span>
            <span v-else>
              {{ recipients.target_count }} / {{ recipients.total_count }}
            </span>
          </h3>
        </div>
      </div>
    </div>

    <input type="hidden" :name="inputName" v-model="stringifyParameters">
  </div>
</template>
<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import SegmentGroupSetup from "@/components/marketing-message/registration-segment/SegmentGroupSetup.vue"

// Props
const props = defineProps({
  targets: Array,
  segmentAvailable: Array,
  name: String,
  dataTestTargetUrl: {
    type: String,
    default: null
  },
  activitiesUrl: {
    required: true,
    type: String,
  },
})

// State
const parameters = ref([])
const segments = ref([])
const inputName = ref('')
const recipients = ref('not available')

// Méthodes
function addNewGroup() {
  parameters.value.push([])
}
function onUpdateGroup(groupToUpdate, group) {
  const index = parameters.value.findIndex((group) => {
    return JSON.stringify(group) === JSON.stringify(groupToUpdate)
  })
  parameters.value[index] = group
}
function onDeleteGroup(groupToRemove) {
  const index = parameters.value.findIndex((group) => {
    return JSON.stringify(group) === JSON.stringify(groupToRemove)
  })
  parameters.value.splice(index, 1)
}

// Watchers
watch(parameters, (param) => {
  if (!props.dataTestTargetUrl) {
    return
  }
  recipients.value = '...'
  axios.post(props.dataTestTargetUrl, {
    target: param
  })
  .then(function (response) {
    recipients.value = response.data
  })
  .catch(function (error) {
    recipients.value = 'Error! Could not reach the API. ' + error
  })
}, { deep: true })

// Computed
const stringifyParameters = computed(() => JSON.stringify(parameters.value))

// Lifecycle
onMounted(() => {
  parameters.value = (props.targets === null ? [] : props.targets)
  segments.value = props.segmentAvailable
  inputName.value = props.name
})
</script>
